module.exports = __webpack_public_path__ + "static/3-709523051b73531b26835a03dd39e2f1.jpg";